"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paragraph = exports.Caption = exports.Header4 = exports.Subheading = exports.Heading = exports.Title = exports.BaseTypographyComponent = exports.getTypographyVariant = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variant = _interopRequireDefault(require("@styled-system/variant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * @typedef {'title'|'heading'|'subheading'|'header4'|'caption'|'paragraph'} TypographyVariant
 * 
 * 
 * @param {TypographyVariant} variant Typography variant
 * @returns 
 */
var getTypographyVariant = function getTypographyVariant(variant) {
  return (0, _styledComponents.css)(["", " ", ""], function (props) {
    return props.theme.typography.baseCSS;
  }, function (props) {
    return props.theme.typography.variants({
      variant: variant
    });
  });
};
/**
 * These Components represent the typographic elements in the gf-styled design system.
 * They are all individually created components, rather than composed (via styled(BASE_COMPONENT))
 * The reason for this is so that way consumers can utilize the `as` prop, instead of `forwardAs`
 * This will reduce cognitive load in deploying these.
 * 
 * Each typographic Component has access to the following props:
 * @property {TypographyVariant} variant -
 *  Defines the css font variants for a given Component.
 * @property {HTMLElement} as - changes the semantic DOM node that this component renders.
 */


exports.getTypographyVariant = getTypographyVariant;
var BaseTypographyComponent = (0, _styledComponents["default"])('div').attrs(function (props) {
  return {
    className: "gf_styled__".concat(props.variant)
  };
}).withConfig({
  displayName: "Typography__BaseTypographyComponent",
  componentId: "sc-1gtdkyu-0"
})(["", " ", ""], function (props) {
  return props.theme.typography.baseCSS;
}, (0, _variant["default"])({
  scale: 'typography'
}));
exports.BaseTypographyComponent = BaseTypographyComponent;
var Title = (0, _styledComponents["default"])(BaseTypographyComponent).withConfig({
  displayName: "Typography__Title",
  componentId: "sc-1gtdkyu-1"
})([""]);
exports.Title = Title;
Title.defaultProps = {
  variant: 'title'
};
var Heading = (0, _styledComponents["default"])(BaseTypographyComponent).withConfig({
  displayName: "Typography__Heading",
  componentId: "sc-1gtdkyu-2"
})([""]);
exports.Heading = Heading;
Heading.defaultProps = {
  variant: 'heading'
};
var Subheading = (0, _styledComponents["default"])(BaseTypographyComponent).withConfig({
  displayName: "Typography__Subheading",
  componentId: "sc-1gtdkyu-3"
})([""]);
exports.Subheading = Subheading;
Subheading.defaultProps = {
  variant: 'subheading'
};
var Header4 = (0, _styledComponents["default"])(BaseTypographyComponent).withConfig({
  displayName: "Typography__Header4",
  componentId: "sc-1gtdkyu-4"
})([""]);
exports.Header4 = Header4;
Header4.defaultProps = {
  variant: 'header4'
};
var Caption = (0, _styledComponents["default"])(BaseTypographyComponent).withConfig({
  displayName: "Typography__Caption",
  componentId: "sc-1gtdkyu-5"
})([""]);
exports.Caption = Caption;
Caption.defaultProps = {
  variant: 'caption'
};
var Paragraph = (0, _styledComponents["default"])(BaseTypographyComponent).withConfig({
  displayName: "Typography__Paragraph",
  componentId: "sc-1gtdkyu-6"
})([""]);
exports.Paragraph = Paragraph;
Paragraph.defaultProps = {
  variant: 'paragraph'
};